import {ApiConfigPort} from '../config/api-config-port';
import {HttpService} from '../../services/http-service';
import {CreateResult, DeleteResult, ListResult, SingleResult} from './lib-rest';

export class PaymentApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async customerPortal(): Promise<SingleResult<PaymentController$CustomerPortalResult> >  {
const url =  new URL('/payments/customer-portal', this.config.host);

return (await HttpService.getAxiosClient().post(url.toString())).data
  }

 public  async handleCreemWebhook(rawBody: string): Promise<Response>  {
const url =  new URL('/payments/webhooks/creem', this.config.host);

return (await HttpService.getAxiosClient().post(url.toString(),JSON.stringify(rawBody))).data
  }

 public  async initiateCheckout(breederId: string, productId: string): Promise<PaymentController$InitiateCheckoutResult>  {
const url =  new URL('/payments/checkout', this.config.host);
    const queryParamsList: { name: string, value: string }[] = [];
    queryParamsList.push({name: 'breederId', value: breederId});
  
    queryParamsList.push({name: 'productId', value: productId});
  
    for (const queryParam of queryParamsList) {
url.searchParams.append(queryParam.name,queryParam.value);
    }

return (await HttpService.getAxiosClient().post(url.toString())).data
  }

 public  async status(): Promise<SingleResult<PaymentController$PaymentStatusResult> >  {
const url =  new URL('/payments/status', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

}

export interface PaymentController$CustomerPortalResult {
  customerPortalLink: string;
}

export interface PaymentController$InitiateCheckoutResult {
  checkoutUrl: string;
  status: string;
}

export interface PaymentController$PaymentStatusResult {
  creemActive: boolean;
  creemCustomer: boolean;
  pastDue: boolean;
}

export class SubscriptionLogsApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async history(breederId: string): Promise<ListResult<string> >  {
const url =  new URL('/subscriptions/logs/' + breederId + '', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

}

export type SubscriptionType = 'TRIAL' | 'INDIVIDUAL' | 'VOLUME'
export class SubscriptionTypeValues {
static readonly   INDIVIDUAL: SubscriptionType = 'INDIVIDUAL';
static readonly   TRIAL: SubscriptionType = 'TRIAL';
static readonly   VOLUME: SubscriptionType = 'VOLUME';
};

export class SubscriptionsApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async get(): Promise<SingleResult<SubscriptionsController$SubscriptionJson> >  {
const url =  new URL('/subscriptions/active', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async listAll(): Promise<ListResult<SubscriptionsController$SubscriptionListJson> >  {
const url =  new URL('/subscriptions', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async subscribe(breederId: string, body?: SubscriptionsController$SubscribeRequestJson): Promise<CreateResult>  {
const url =  new URL('/subscriptions/' + breederId + '', this.config.host);

return (await HttpService.getAxiosClient().post(url.toString(),JSON.stringify(body))).data
  }

 public  async subscribeAssociation(registryId: string, body: SubscriptionsController$SubscribeRequestJson): Promise<CreateResult>  {
const url =  new URL('/subscriptions/registry/' + registryId + '', this.config.host);

return (await HttpService.getAxiosClient().post(url.toString(),JSON.stringify(body))).data
  }

 public  async unsubscribe(breederId: string): Promise<DeleteResult>  {
const url =  new URL('/subscriptions/' + breederId + '', this.config.host);

return (await HttpService.getAxiosClient().delete(url.toString())).data
  }

 public  async unsubscribeAssociation(registryId: string): Promise<DeleteResult>  {
const url =  new URL('/subscriptions/registry/' + registryId + '', this.config.host);

return (await HttpService.getAxiosClient().delete(url.toString())).data
  }

}

export interface SubscriptionsController$SubscribeRequestJson {
  duration: number;
  start: any | null;
  type: SubscriptionType;
}

export interface SubscriptionsController$SubscriptionJson {
  cancelledAt: any;
  expiresAt: any;
  type: SubscriptionType;
  validFrom: any;
}

export interface SubscriptionsController$SubscriptionListJson {
  breederId: string;
  subscription: SubscriptionsController$SubscriptionJson;
}

export class SubscriptionsTestApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async testActive(): Promise<string>  {
const url =  new URL('/subscriptions/test/active', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async testExpired(): Promise<string>  {
const url =  new URL('/subscriptions/test/expired', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

}

